import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const PendingApproval = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default PendingApproval